import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../data.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotifyUsersInput } from 'src/app/features/notify-users/notify-users-input';

@Injectable({
    providedIn: 'root'
  })

export class NotifyUsersService extends DataService{
  private baseURI = this.apiUri + '/notifyusers/';

  constructor(http: HttpClient) {
    super(http);
  }

  sendEmails(notifyUsersIn:NotifyUsersInput){
    console.log("before sending request post:::");
    console.log(notifyUsersIn);
    return this.http.post(this.baseURI + 'sendemails', notifyUsersIn,{responseType: 'text'}).pipe(catchError(this.handleError));
  }
  listOfImages(busType: any): Observable<any[]>{
    this.setUri(this.baseURI + 'images/' + busType + '/busType');
    return this.get().pipe(catchError(this.handleError));
  }
}